import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

export const HeighEducateIdea = (props) => {
  const { t } = useTranslation();
  const { ideas, scale, theme } = props;
  return (
    <section>
      <div className="heigh-educate-idea">
        <div className="inner">
          <div className="content">
            <h2 className="customer-title">
              {t("customer.heigh-educate.ideas.title")}
            </h2>
            <div className="customer-idea-responsive">
              <ResponsiveMasonry columnsCountBreakPoints={scale}>
                <Masonry columnsCount={4} gutter={70}>
                  {ideas.map((idea) => {
                    return (
                      <div className="card">
                        <div className="card-content">
                          <div className="text-warp">
                            <span
                              className="dot"
                              style={{ background: theme }}
                            ></span>
                            <span className="text">{idea.descript}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Masonry>
              </ResponsiveMasonry>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
